const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<pre`);
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` class="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(1, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(` aria-describedby="shcb-language-16" data-shcb-language-name="JavaScript" data-shcb-language-slug="javascript"><div><code class="hljs language-javascript shcb-code-table`);
                if ((context.has(`lineNumbers`) ? context.get(`lineNumbers`) : null)) {
                    this.echo(` shcb-line-numbers`);
                }
                if ((context.has(`wrapLines`) ? context.get(`wrapLines`) : null)) {
                    this.echo(` shcb-wrap-lines`);
                }
                this.echo(`"><span class="shcb-loc"><span><span class="hljs-comment">// Sweet useless condition</span>
</span></span><span class="shcb-loc"><span><span class="hljs-keyword">if</span> (<span class="hljs-keyword">this</span> !== <span class="hljs-string">'that'</span> || truth == <span class="hljs-literal">false</span>) {
</span></span><mark class="shcb-loc"><span>  <span class="hljs-keyword">new</span> <span class="hljs-built_in">RegExp</span>(<span class="hljs-regexp">/ab+c/</span>, <span class="hljs-string">'i'</span>);
</span></mark><span class="shcb-loc"><span>  boyHowdy(<span class="hljs-number">5</span>, <span class="hljs-string">'something'</span>);
</span></span><span class="shcb-loc"><span>  <span class="hljs-built_in">console</span>.log(<span class="hljs-string">'hello world'</span>);
</span></span><span class="shcb-loc"><span>  <span class="hljs-keyword">return</span> (<span class="hljs-number">2</span> * <span class="hljs-number">4</span>) / <span class="hljs-number">3</span>;
</span></span><span class="shcb-loc"><span>}
</span></span><span class="shcb-loc"><span>
</span></span><span class="shcb-loc"><span><span class="hljs-class"><span class="hljs-keyword">class</span> <span class="hljs-title">Bread</span> <span class="hljs-keyword">extends</span> <span class="hljs-title">Dough</span> </span>{
</span></span><span class="shcb-loc"><span>  <span class="hljs-keyword">constructor</span>(slices = 12) {
</span></span><mark class="shcb-loc"><span>    <span class="hljs-keyword">if</span> (slices &gt; <span class="hljs-number">24</span>) {
</span></mark><mark class="shcb-loc"><span>      <span class="hljs-keyword">throw</span> <span class="hljs-keyword">new</span> <span class="hljs-built_in">Error</span>(<span class="hljs-string">'Too much bread'</span>);
</span></mark><mark class="shcb-loc"><span>    }
</span></mark><span class="shcb-loc"><span>
</span></span><span class="shcb-loc"><span>    <span class="hljs-keyword">this</span>.slices = <span class="hljs-string">\`There are <span class="hljs-subst">\${slices}</span> slices\`</span>;
</span></span><span class="shcb-loc"><span>  }
</span></span><span class="shcb-loc"><span>}
</span></span><span class="shcb-loc"><span>
</span></span><span class="shcb-loc"><span><span class="hljs-keyword">const</span> sum = <span class="hljs-function">(<span class="hljs-params">...args</span>) =&gt;</span> {
</span></span><span class="shcb-loc"><span>  <span class="hljs-keyword">return</span> args.reduce(<span class="hljs-function">(<span class="hljs-params">a, b</span>) =&gt;</span> a + b, <span class="hljs-number">0</span>);
</span></span><span class="shcb-loc"><span>};
</span></span></code></div><small class="shcb-language" id="shcb-language-16"><span class="shcb-language__label">Code language:</span> <span class="shcb-language__name">JavaScript</span> <span class="shcb-language__paren">(</span><span class="shcb-language__slug">javascript</span><span class="shcb-language__paren">)</span></small></pre>
`);
            }

            getTemplateName() {
                return `f0119c89a7332ed1d33f834c44936b9f11216cef6908a7a61af57328829d1855`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `f0119c89a7332ed1d33f834c44936b9f11216cef6908a7a61af57328829d1855`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'f0119c89a7332ed1d33f834c44936b9f11216cef6908a7a61af57328829d1855');

let template = env.loadTemplate('f0119c89a7332ed1d33f834c44936b9f11216cef6908a7a61af57328829d1855');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/vendor/shcb/demo/code-table.twig", args: context }
     );
     return rendered;;
};